import * as React from 'react'
import { useIsCompactViewport } from '@repo/studio-hooks-dom/use-breakpoint'
import { snapAidaPresentationToFullscreen, useAidaOverlayStore } from '../stores/overlay-store'

/** Keeps dock/float off sub-lg viewports; inset width is handled via `StudioLayoutContentInsetProvider`. */
export function useAidaDockLayout() {
  const open = useAidaOverlayStore(state => state.open)
  const mode = useAidaOverlayStore(state => state.mode)
  const isCompact = useIsCompactViewport()

  React.useEffect(() => {
    if (open && isCompact && (mode === 'dock' || mode === 'floating')) {
      snapAidaPresentationToFullscreen()
    }
  }, [isCompact, mode, open])
}
